import { render, staticRenderFns } from "./Confessions.vue?vue&type=template&id=2b52cf38&scoped=true"
import script from "./Confessions.vue?vue&type=script&lang=ts"
export * from "./Confessions.vue?vue&type=script&lang=ts"
import style0 from "./Confessions.vue?vue&type=style&index=0&id=2b52cf38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b52cf38",
  null
  
)

export default component.exports